<template>

    <body style="direction: rtl; text-align: right; padding: 70px 0px 0 0px;">
        <div class="container mb-4">
            <!-- Header START -->
            <Header pageTitle="الدردشات" />
            <!-- Header END -->

            <!-- Chats START -->
            <div class="chat-cards mt-3">
                <!-- Card START -->
                <router-link v-for="chat in chats" :key="chat.id" :to="{ name: 'ChatPage', params: { id: chat.id } }"
                    class="chat-card d-flex align-items-center mb-3 rounded shadow-sm text-decoration-none">
                    <!-- User avatar -->
                    <div class="avatar rounded-circle bg-light d-flex justify-content-center align-items-center me-1">
                        <i class="bi bi-person" style="font-size: 2rem; color: #6c757d;"></i>
                    </div>
                    <!-- Chat info -->
                    <div class="me-2 chat-info flex-grow-1">
                        <!-- First row: Name and time -->
                        <div class="d-flex justify-content-between align-items-center mb-2">
                            <p style="font-weight: bold; color: #296080;" class="mb-1">{{ chat.name }}</p>
                            <small style="color: #6c757d;">{{ chat.time }}</small>
                        </div>
                        <!-- Second row: Message and unread count -->
                        <div class="d-flex justify-content-between align-items-center">
                            <p class="small mb-0 text-truncate" style="color: #6c757d; flex-grow: 1;">{{
                                chat.message }}</p>
                            <div v-if="chat.unread > 0" class="badge rounded-circle ms-2"
                                style="width: 20px;background-color: #296080; height: 20px; display: flex; justify-content: center; align-items: center;">
                                {{ chat.unread }}
                            </div>
                        </div>
                    </div>
                </router-link>
                <!-- Card END -->
            </div>
            <!-- Chats END -->
        </div>
        <!-- Footer START -->
        <Footer />
        <!-- Footer END -->
    </body>
</template>

<script>
import Header from "../../components/header.vue";
import Footer from "../../components/footer.vue";

export default {
    name: "ProfessionPage",
    components: {
        Header,
        Footer,
    },
    data() {
        return {
            chats: [
                { id: 1, name: "أحمد العلي", time: "قبل 10 دقائق", message: "مرحباً، متى يمكننا بدء العمل؟", unread: 3 },
                { id: 2, name: "سارة محمد", time: "اليوم 9:30 صباحاً", message: "شكراً على التوضيح. سأراج...", unread: 0 },
                { id: 3, name: "خالد إبراهيم", time: "أمس 6:45 مساءً", message: "تم استلام الملفات. شكراً ...", unread: 1 },
                { id: 4, name: "نورة اليوسف", time: "أمس 4:15 مساءً", message: "كم المدة المتوقعة لإنجاز ا...", unread: 0 },
                { id: 5, name: "طارق الحلي", time: "قبل يومين", message: "هل يمكننا مناقشة التعديلات؟", unread: 2 },
            ],
        };
    },
};
</script>

<style scoped>
.chat-card {
    background-color: #fff;
    border: 1px solid #dee2e6;
    padding: 0.6rem 0.5rem 1rem 0.8rem;
}

.avatar {
    width: 50px;
    height: 50px;
}

.chat-info p {
    margin: 0;
}
</style>